'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images';
import { AppDownloadAction } from './app-download-action';
import { AppPhone } from './app-phone';
import { useUpsellImpression } from './use-upsell-impression';
export function AppUpsellSlide() {
  const $ = _c(12);
  const t = useTranslations("app_upsells");
  const ref = useUpsellImpression("feed");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="shrink-0 lg:absolute lg:top-6 lg:left-6"><OptimizedImage variant="thumbnail" src="/icons/morfi-logomark.svg" alt="" size="size-9" preview={false} nsfw={false} loadReveal="none" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("feed_title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex min-w-0 flex-1 items-center gap-3 text-foreground-primary lg:flex-none">{t0}<div className="min-w-0"><h2 className="app-upsell-feed-title">{t1}</h2></div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AppDownloadAction surface="feed" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="app-upsell-feed-copy">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="app-upsell-feed-art"><AppPhone /></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ref || $[10] !== t4) {
    t6 = <div className="app-upsell-feed" ref={ref} data-testid="app-upsell-slide">{t4}{t5}</div>;
    $[9] = ref;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}